import { Divider, Header } from 'semantic-ui-react'
import { TodayActivitySection } from './TodayActivitySection/TodayActivitySection'
import { MyParkSection } from './MyParkSection/MyParkSection'


const Dashboard = () => {
    return (
      <>
          <Divider horizontal>
              <Header as="h4" color="teal">
                  Recommandations
              </Header>
          </Divider>

          <TodayActivitySection />

          <MyParkSection />

          <Divider horizontal>
              <Header horizontal as="h4" color="teal">
                  Mon offre
              </Header>
          </Divider>
      </>
    )
}

export { Dashboard }
